import Card from '../../components/Card'
import StatusBadge from '../../components/StatusBadge'
import { scormStrings as S } from './strings'
import './ScormResults.css'

const tone = (status) => status === 'passed' || status === 'correct' ? 'success'
  : status === 'failed' || status === 'wrong' ? 'danger' : 'dark'
const questionLabel = (result) => ['correct', 'wrong', 'neutral', 'unanticipated', 'unreported'].includes(result)
  ? S[result] : result || S.unreported

export default function ScormResults({ results }) {
  if (!results.length) return null
  return <Card className="scorm-results" title={S.title} subtitle={S.latest}>
    {results.map((result) => <section className="scorm-result" key={result.CourseId}>
      <h3><bdi>{result.CourseName}</bdi></h3>
      <p className="scorm-result__summary">
        <StatusBadge tone={tone(result.Status)}>{S[result.Status] ?? S.unreported}</StatusBadge>
        <span>{S.score}: <bdi>{result.Percentage != null ? `${result.Percentage}%`
          : result.Score != null ? `${result.Score}${result.MaximumScore != null ? ` / ${result.MaximumScore}` : ''}`
            : S.unreported}</bdi></span>
      </p>
      {result.Questions?.length ? <details>
        <summary>{S.questions} ({result.Questions.length})</summary>
        <p>{S.codes}</p>
        <div className="scorm-result__scroll">
          <table>
            <thead><tr>{[S.question, S.response, S.correctResponse, S.result].map((label) => <th key={label} scope="col">{label}</th>)}</tr></thead>
            <tbody>{result.Questions.map((question, index) => <tr key={`${index}-${question.Id}`}>
              <th scope="row"><bdi>{question.Id}</bdi></th>
              <td><bdi>{question.Response ?? S.unreported}</bdi></td>
              <td><bdi>{question.CorrectResponses?.join(' | ') || S.unreported}</bdi></td>
              <td><StatusBadge tone={tone(question.Result)}>{questionLabel(question.Result)}</StatusBadge></td>
            </tr>)}</tbody>
          </table>
        </div>
      </details> : <p>{S.noQuestions}</p>}
    </section>)}
  </Card>
}
